import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card';
import { Promise } from '@/data/promises';
import StatusBadge from './StatusBadge';
import { formatDate } from '@/utils/date';
import { ExternalLink } from 'lucide-react';

interface PromiseCardProps {
  promise: Promise;
}

const PromiseCard = ({ promise }: PromiseCardProps) => {
  const handleSourceClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open(promise.sourceUrl, '_blank', 'noopener,noreferrer');
  };

  // Optimized image URL - no longer needed
  // const optimizedImageUrl = `${promise.imageUrl}?auto=format&w=400&q=75`;

  return (
    <Link to={`/promise/${promise.id}`}>
      <Card className="h-full overflow-hidden hover:shadow-md transition-shadow duration-200 flex flex-col">
        <CardHeader className="pb-2">
          <div className="flex flex-col">
            <h3 className="font-bold text-lg line-clamp-2">{promise.title}</h3>
            <p className="text-sm mt-1 text-nepal-blue font-semibold">{promise.sector}</p>
          </div>
        </CardHeader>
        <CardContent className="pb-2 flex-grow">
          <p className="text-sm text-gray-600 font-medium">
            {promise.politician} • {promise.politicalParty}
          </p>
          <p className="text-xs text-gray-500 mt-1">
            Made on {formatDate(promise.dateMade)}
            {promise.deadline && ` • Deadline: ${formatDate(promise.deadline)}`}
          </p>
          <div className="mt-3">
            <StatusBadge status={promise.status} />
          </div>
        </CardContent>
        <CardFooter className="pt-0">
          <button 
            onClick={handleSourceClick}
            className="text-xs text-gray-500 flex items-center hover:text-nepal-blue transition-colors"
          >
            <span className="underline">View source</span>
            <ExternalLink className="w-3 h-3 ml-1" />
          </button>
        </CardFooter>
      </Card>
    </Link>
  );
};

export default PromiseCard;
